import {
  FetchCampaignOwnerEmployeesLookupRequest,
  FetchCampaignOwnerEmployeesLookupResponse,
} from "./types";
import axiosInstance from "@/api/axiosInstance";

export const fetchCampaignOwnerEmployeesLookup = async (
  requestData: FetchCampaignOwnerEmployeesLookupRequest,
): Promise<FetchCampaignOwnerEmployeesLookupResponse> => {
  const params = {
    ...requestData,
  };

  const response =
    await axiosInstance.get<FetchCampaignOwnerEmployeesLookupResponse>(
      "/api/private/campaign/owner-employees/lookup",
      { params },
    );

  return response.data;
};